import { MedcardDocumentType } from '~/features/Medcard/enums'

export type GetDocumentGroupDatePayload = {
  documentType: MedcardDocumentType
  dtGenerated: DateTimeISO | null
  dtVisit: DateTimeISO | null
}

export default (group: GetDocumentGroupDatePayload) => {
  return [MedcardDocumentType.Analysis, MedcardDocumentType.Certificate].includes(group.documentType)
    ? group.dtVisit!
    : group.dtGenerated || group.dtVisit!
}
